import React, { useState } from 'react';
import SelectorVentanas, { DIAS_SEMANA, FRANJAS } from '../servicio/SelectorVentanas';
import HorarioFijo, { esHorarioFijo } from './HorarioFijo';
import { resumenVentanas } from '../../utils/ordenes';

// ¿Cuándo pueden recibirnos? (16-oct-2026): días y franjas, u horario fijo. Lo usan el
// pedido nuevo y "Cambiar horario" de un pedido ya cargado.
const todas = (franjas) => DIAS_SEMANA.flatMap(d => franjas.map(f => ({ dia: d.id, franja: f })));
const ATAJOS = [
    { label: 'Cualquier día', ventanas: () => todas(FRANJAS.map(f => f.id)) },
    { label: 'Mañanas (8 a 12)', ventanas: () => todas(['08:00-10:00', '10:00-12:00']) },
    { label: 'Tardes (12 a 16)', ventanas: () => todas(['12:00-14:00', '14:00-16:00']) },
];

export default function ElegirVentanas({ value, onChange, opcional = false }) {
    const [fijo, setFijo] = useState(() => esHorarioFijo(value));
    const cambiarModo = (v) => { if (v !== fijo) { setFijo(v); onChange([]); } };

    return (
        <section className="space-y-2">
            <div className="grid grid-cols-2 gap-1.5 p-1 rounded-2xl bg-chip">
                {[[false, 'Días y franjas'], [true, 'Horario fijo']].map(([v, l]) => (
                    <button key={l} type="button" onClick={() => cambiarModo(v)} aria-pressed={fijo === v}
                        className={`h-10 rounded-xl text-label font-black active:scale-95 ${fijo === v ? 'bg-card text-ink shadow-sm' : 'text-muted'}`}>{l}</button>
                ))}
            </div>
            {fijo ? <HorarioFijo value={value} onChange={onChange} /> : (<>
                <div className="flex flex-wrap gap-1.5">
                    {ATAJOS.map(a => (
                        <button key={a.label} type="button" onClick={() => onChange(a.ventanas())}
                            className="h-9 px-3 rounded-full bg-chip text-caption font-bold text-secondary active:scale-95">{a.label}</button>
                    ))}
                    {value.length > 0 && (
                        <button type="button" onClick={() => onChange([])} className="h-9 px-3 rounded-full text-caption font-bold text-muted underline">Borrar</button>
                    )}
                </div>
                <SelectorVentanas value={value} onChange={onChange} opcional={opcional}
                    ayuda="Marcá los días y horarios en que hay alguien para recibir al técnico. Él elige el día dentro de lo que marques y te avisamos." />
            </>)}
            {value.length > 0 && (
                <div className="p-3 rounded-xl bg-chip">
                    {resumenVentanas(value).map(l => <p key={l} className="text-caption font-bold text-ink">{l}</p>)}
                </div>
            )}
        </section>
    );
}
